export default __webpack_public_path__ + "static/media/BMWFavicon.317bec64.ico";